import { makePrefixAdder } from '../../redux/utils/type-utils';

const addPrefixTo = makePrefixAdder('fetchFilteredStats');

export const REQUEST = addPrefixTo('REQUEST');
export const SUCCESS = addPrefixTo('SUCCESS');
export const CANCEL = addPrefixTo('CANCEL');
export const CANCELLED = addPrefixTo('CANCELLED');
